const reactInstructions = (account, coreEventName) => {
  const re = `import React, { useEffect } from 'react'
import Pmf from 'pmf-engine-sdk'

const pmf = new Pmf('splint-invest')

export default function HomeScreen() {
  useEffect(() => {
    pmf.identify('user id')
    pmf.event('default')
  }, [])

  ...
}
  `

  const gc = `import React, { useEffect, useState } from 'react'
import Pmf from 'pmf-engine-sdk'
import { Modal } from '...somewhere :)'
  
export default function HomeScreen() {
  const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false)
  const [feedbackUrl, setFeedbackUrl] = useState<string | null>(null)

  useEffect(() => {
    const checkForFeedback = async () => {
      const feedback = await pmf.getCommand()

      if (feedback?.type === 'form') {
        setShowFeedbackModal(true)
        setFeedbackUrl(feedback.url)
      }
    }

    checkForFeedback()
  }, [])

  return (
    <div>
      <Modal 
        isOpen={showFeedbackModal} 
        toggle={() => setShowFeedbackModal(false)}>
      >
        <iframe src={feedbackUrl} />
      </Modal>
    </div>
  )
}
  `

  return { re, gc }
}

export default reactInstructions
